const FIELD_MAP = {
  haberBolsilloReajustado: {
    path: ['resumenEjecutivo', 'haberBolsilloReajustado'],
    compare: (a, b) => a.toFixed(2) === b.toFixed(2),
    precision: 2,
  },
  retroactivoTotal: {
    path: ['resumenEjecutivo', 'retroactivoTotal'],
    compare: (a, b) => a.toFixed(2) === b.toFixed(2),
    precision: 2,
  },
  pbu: {
    path: ['resumenEjecutivo', 'prestaciones', 'pbu'],
    compare: (a, b) => a.toFixed(2) === b.toFixed(2),
    precision: 2,
  },
  pc: {
    path: ['resumenEjecutivo', 'prestaciones', 'pc'],
    compare: (a, b) => a.toFixed(2) === b.toFixed(2),
    precision: 2,
  },
  pap: {
    path: ['resumenEjecutivo', 'prestaciones', 'pap'],
    compare: (a, b) => a.toFixed(2) === b.toFixed(2),
    precision: 2,
  },
  movilidadAcumulada: {
    path: ['resumenEjecutivo', 'prestaciones', 'movilidadAcumulada'],
    compare: (a, b) => a.toFixed(4) === b.toFixed(4),
    precision: 4,
  },
  divisorPromedioAplicado: {
    path: ['resumenEjecutivo', 'prestaciones', 'divisorPromedioAplicado'],
    compare: (a, b) => a === b,
    precision: null,
  },
  scenarioKey: {
    path: ['diagnosticoCalculo', 'scenarioKey'],
    compare: (a, b) => String(a) === String(b),
    precision: null,
  },
  formulaPath: {
    path: ['diagnosticoCalculo', 'formulaPath'],
    compare: (a, b) => String(a) === String(b),
    precision: null,
  },
  incrementoMensualPct: {
    path: ['resumenEjecutivo', 'incrementoMensualPct'],
    compare: (a, b) => a.toFixed(2) === b.toFixed(2),
    precision: 2,
  },
}

function getValue(obj, path) {
  return path.reduce((o, key) => (o != null ? o[key] : undefined), obj)
}

function isNumeric(v) {
  return typeof v === 'number' && Number.isFinite(v)
}

export function compareResults(ctx, golden) {
  const fields = []
  let passedCount = 0
  let total = 0

  for (const [fieldName, config] of Object.entries(FIELD_MAP)) {
    if (!(fieldName in golden)) continue
    if (golden[fieldName] === null || golden[fieldName] === undefined) continue

    const actualValue = getValue(ctx, config.path)
    const expectedValue = golden[fieldName]

    // Compare only when actual value is present and valid
    let passed = false
    if (actualValue !== undefined && actualValue !== null) {
      if (config.precision !== null && isNumeric(expectedValue)) {
        passed = config.compare(actualValue, expectedValue)
      } else if (config.precision === null) {
        passed = config.compare(actualValue, expectedValue)
      }
    }

    if (passed) passedCount++
    total++

    fields.push({
      field: fieldName,
      expected: expectedValue,
      actual: actualValue,
      passed,
      precision: config.precision,
    })
  }

  return { passed: passedCount === total, total, passedCount, fields }
}
